import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Views } from './components/views';

const A_BonosPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: false,
    },
    {
      title: 'Historial',
      path: '',
      isSeparator: true,
      isActive: true,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Bonos</PageTitle>
      <Views/>
    </>
  );
};

export {A_BonosPage}